import { render, staticRenderFns } from "./IntelligentBookingResult.vue?vue&type=template&id=6297001e&"
import script from "./IntelligentBookingResult.vue?vue&type=script&lang=js&"
export * from "./IntelligentBookingResult.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentBookingResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6297001e')) {
      api.createRecord('6297001e', component.options)
    } else {
      api.reload('6297001e', component.options)
    }
    module.hot.accept("./IntelligentBookingResult.vue?vue&type=template&id=6297001e&", function () {
      api.rerender('6297001e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResult.vue"
export default component.exports